import { Component } from '@angular/core';
import {environment} from "../../../../../../environments/environment";

@Component({
  selector: 'app-sales-phone-enrollment-manual-fail-message',
  templateUrl: './sales-phone-enrollment-manual-fail-message.component.html',
  styles: [
  ]
})
export class SalesPhoneEnrollmentManualFailMessageComponent {
  customerServicePhone = environment.global.country.customerServicePhone;

}
